// WS1 — co-located query-key factory for the document-request (collection
// package) surface. Archive + soft-Delete mutations must invalidate the portal
// account reads so the account detail page refreshes; those are NEW invalidation
// targets, and the staleAfterSaveGate forbids inline `queryKey: [` literals
// outside a *Keys file (and has no baseline slack for adding them to the page),
// so the array literals live here. The page's pre-existing inline keys
// (collection-package / collection-staging / collection-packages) stay as-is.

export const collectionPackagesKeys = {
  /** Broad prefix — RQ v5 prefix-matches every portal-account-packages read
   *  (the account detail `["portal-account-packages", accountId, showAll]` and
   *  the absorption `["portal-account-packages", portalUserId, …]` shapes). */
  portalAccountPackagesPrefix: ["portal-account-packages"] as const,
  /** Broad prefix — matches `["portal-account-summary", accountId]`. */
  portalAccountSummaryPrefix: ["portal-account-summary"] as const,
  /** Broad prefix — matches every package-detail read
   *  (`["collection-package", id, showArchived]`). Review decisions change the
   *  package's item statuses and roll-up, so they invalidate it. */
  packageDetailPrefix: ["collection-package"] as const,
};
